import { OWListenerDelegate, OWListener } from '../common';
type onScreenPropertyChangedEvent =
  overwolf.windows.onScreenPropertyChangedEvent;
type WindowStateChangedEvent = overwolf.windows.WindowStateChangedEvent;

// -----------------------------------------------------------------------------
export interface OWWindowsListenerDelegate extends OWListenerDelegate {
  onWindowStateChanged?(info: WindowStateChangedEvent);
  onWindowClosed?(windowName: string);
  onWindowMinimized?(windowName: string);
  onWindowMaximized?(windowName: string);
  onWindowRestored?(windowName: string);
  onScreenPropertyChanged?(event: onScreenPropertyChangedEvent);
  onAltF4Blocked?(windowId: string);
}

// -----------------------------------------------------------------------------
export class OWWindowsListener extends OWListener<OWWindowsListenerDelegate> {
  // ---------------------------------------------------------------------------
  constructor(delegate: OWWindowsListenerDelegate, autoStart = false) {
    super(delegate);

    if (autoStart) {
      this.start();
    }
  }

  // ---------------------------------------------------------------------------
  public start(): void {
    super.start();
    overwolf.windows.onStateChanged.addListener(this.onWindowStateChanged);

    overwolf.windows.onScreenPropertyChanged.addListener(
      this.onScreenPropertyChanged
    );

    overwolf.windows.onAltF4Blocked.addListener(this.onAltF4Blocked);
  }

  // ---------------------------------------------------------------------------
  public stop(): void {
    overwolf.windows.onStateChanged.removeListener(this.onWindowStateChanged);

    overwolf.windows.onScreenPropertyChanged.removeListener(
      this.onScreenPropertyChanged
    );

    overwolf.windows.onAltF4Blocked.removeListener(this.onAltF4Blocked);
  }

  // ---------------------------------------------------------------------------
  private onWindowStateChanged = (info: WindowStateChangedEvent): void => {
    if (!info) {
      return;
    }

    if (this._delegate.onWindowStateChanged) {
      this._delegate.onWindowStateChanged(info);
    }

    if (info.window_state === 'closed') {
      if (this._delegate.onWindowClosed) {
        this._delegate.onWindowClosed(info.window_name);
      }
    }

    if (info.window_state === 'minimized') {
      if (this._delegate.onWindowMinimized) {
        this._delegate.onWindowMinimized(info.window_name);
      }
    }

    if (info.window_state === 'maximized') {
      if (this._delegate.onWindowMaximized) {
        this._delegate.onWindowMaximized(info.window_name);
      }
    }

    if (info.window_state === 'normal') {
      if (this._delegate.onWindowRestored) {
        this._delegate.onWindowRestored(info.window_name);
      }
    }
  }

  // ---------------------------------------------------------------------------
  private onScreenPropertyChanged = (event: onScreenPropertyChangedEvent) => {
    if (this._delegate.onScreenPropertyChanged) {
      this._delegate.onScreenPropertyChanged(event);
    }
  }

  // ---------------------------------------------------------------------------
  private onAltF4Blocked = (event: overwolf.windows.AltF4BlockedEvent) => {
    if (this._delegate.onAltF4Blocked) {
      this._delegate.onAltF4Blocked(event.id);
    }
  }

}
